import {AddressTypes} from "../utils/constants";
import HelperService from "../services/helper-service";

export default function AddressCell({ address, edit, del, onSuccess, className, ...props}) {
  return (
    <>
      <div className={"d-flex justify-content-between align-items-start bg-light-lighten p-2 rounded gap-2 mb-2 "+className}>
        <div>
          <span className="mdi mdi-office-building"></span>
          {address?.title && <strong>{address.title}</strong>}
          {address.type !== AddressTypes.default.val && <div>{HelperService.getObjByKey(Object.values(AddressTypes), 'val', address.type)?.title}</div>}
        </div>
        <div className="w-100">
          <div>
            {address.street} {address.street_plan_number ? address.street_plan_number + ' / ' + address.street_number : address.street_number}
          </div>
          <div>{address.city}</div>
          <div>{address.zip}</div>
          <div>{address.country?.title}</div>
        </div>
        {(edit||del) && <div className={"d-inline-flex"}>
          {edit && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-primary ms-1" onClick={()=>edit(address)}><span className="mdi mdi-pencil" title="Upraviť"></span></button>}
          {del && <button type="button" className="btn btn-sm btn-circle btn-light hover-text-danger ms-1" onClick={()=>del(address)}><span className="mdi mdi-trash-can" title="Zmazať"></span></button>}
        </div>}
      </div>
    </>
  );
}
